/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function($) {
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
    });

  $(".twm_menu .twimenu").on("mouseover", function () {
    var h=$(this).attr('data-handle');
    $('.megatwm').hide();
    $('.'+h+'_megatwm').show();
  });

  
    if($(window).width() < 768) {
        $('.Header__FlexItem--link .Drawer__Open').click(function() {
            $('#sidebar-menu').attr('aria-hidden', false);
            $('.PageOverlay').addClass('is-visible');
        });

        $('#sidebar-menu .Drawer__Close').on('click', function() {
            $('#sidebar-menu').attr('aria-hidden', true);
            $('.PageOverlay').removeClass('is-visible');
        });
    } else {
        $('.Header__FlexItem--link').hover(function() {
            $('#sidebar-menu').attr('aria-hidden', false);
        }, function() {
            $('#sidebar-menu').attr('aria-hidden', true);
        });
    }

    $(document).ready(function() {
        $('.article-slider-wrapper').slick({
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            autoplay: true,
            arrows: false,
            autoplaySpeed: 3000
        });

        $('.article-action-buttons .scroll-top-button a').on('click', function() {
            window.scroll({
                top: 0, 
                left: 0, 
                behavior: 'smooth'
            });
        });

        $('.product-special-infos .info-item').each(function(index) {
            $(this).on('click', function() {
                
                var dataIInfo = $(this).data('info');

                $('.product-infos-modal').addClass('hidden');
                $('.product-infos-modal__wrapper').addClass('hidden');
                $('.product-infos-modal--overlay').addClass('hidden');

                $('.product-infos-modal').each(function(index) {
                    if($(this).data('info') == dataIInfo) {
                        $(this).removeClass('hidden');
                        $('.product-infos-modal__wrapper').removeClass('hidden');
                        $('.product-infos-modal--overlay').removeClass('hidden');
                    }
                });
            });
        });

        $('.product-infos-modal .close-modal').on('click', function() {
            $('.product-infos-modal').addClass('hidden');
            $('.product-infos-modal__wrapper').addClass('hidden');
            $('.product-infos-modal--overlay').addClass('hidden');
        });

        /**
         * Upsell products
         */

        $('.upsell-products__item .ProductItem__Wrapper').each(function(index) {
            $(this).on('click', function(e) {
                e.preventDefault();
                var productInfo = $.parseJSON($(this).next().text());
                
                var productImages = productInfo.product.images;
                var productTitle = productInfo.product.title;
                var productPrice = productInfo.product.price / 100;
                // var productDescription = productInfo.product.description;
                var productId = productInfo.product.id;
                var productOptions = productInfo.product.options;
                var selectedVariantId = productInfo.selected_variant_id;
                var variants = productInfo.product.variants;
                
                var productImageHTML = "";
                var productMetaInfoHTML = "";

                for(var i = 0; i < productImages.length; i++) {
                    productImageHTML += "<div class='product-image'><img class='Image--fadeIn Image--lazyLoaded' src='" + productImages[i] + "'></div>";
                }

                $('.product-image-wrapper').html(productImageHTML);

                productMetaInfoHTML += "<h1 class='ProductMeta__Title Heading u-h4'>" + productTitle + "</h1>";
                productMetaInfoHTML += "<div class='ProductMeta__PriceList Heading'><span class='ProductMeta__Price Price Text--subdued u-h4'>" + USDollar.format(productPrice) + "</span></div>";
                // productMetaInfoHTML += "<div class='ProductMeta__Description'>" + productDescription + "</div>";

                $('.selected-upsell-product-wrapper .product-info-wrapper .ProductMeta').html(productMetaInfoHTML);

                var productAddToCartForm = "<form method='post' class='upsell-product-form' action='/cart/add' id='product_form_" + productId + "' accept-charset='UTF-8' enctype='multipart/form-data'>";
                productAddToCartForm += "<input type='hidden' name='product-id' value='" + productId + "'>";
                productAddToCartForm += "<input type='hidden' name='quantity' value='1'>";
                productAddToCartForm += "<input type='hidden' name='id' value='" + selectedVariantId + "'>";
                productAddToCartForm += "<div class='ProductForm__Variants'>";

                for (var j = 0; j < productOptions.length; j++) {
                    var optionName = productOptions[j];
                    var selectedColorValue = "";
                    var selectedSizeValue = "";
                    var colorOptionClass = "";
                    
                    for (var k = 0; k < variants.length; k++) {
                        if (selectedVariantId === variants[k].id) {
                            if (optionName == 'Color') {
                                selectedColorValue = variants[k].options[0];
                                colorOptionClass = "ProductForm__Label__Color";
                            } else {
                                selectedSizeValue = variants[k].options[1];
                            }
                        }
                    }

                    productAddToCartForm += "<span class='ProductForm__Label " + colorOptionClass + "'>" + optionName + ": " + selectedColorValue;
                    productAddToCartForm += "</span>";

                    if (optionName == 'Color') {
                        productAddToCartForm += "<ul class='ColorSwatchList HorizontalList HorizontalList--spacingTight'>";

                        var colorOptions = [];
                        var colorSwatchImages = [];

                        for (var x = 0; x < variants.length; x++) {
                            colorOptions.push(variants[x].options[0]);
                            colorSwatchImages.push(variants[x].featured_image.src);
                        }
                        
                        var newSetColorOptions = new Set(colorOptions);
                        var newSetColorOptions1 = [...newSetColorOptions];

                        var newSetColorSwarchImages = new Set(colorSwatchImages);
                        var newSetColorSwarchImages1 = [...newSetColorSwarchImages];

                        for (var y = 0; y < newSetColorOptions1.length; y++) {
                            var checkedColorValue = "";

                            if (selectedColorValue == newSetColorOptions1[y]) {
                                checkedColorValue = "checked";
                            }

                            productAddToCartForm += "<li class='HorizontalList__Item'>";
                            productAddToCartForm += "<input type='radio' id='option-upsell-product-template-" + y + "' class='ColorSwatch__Radio' name='option-1' value='" + newSetColorOptions1[y] + "' data-option-position='" + (j + 1) + "' " + checkedColorValue + ">";
                            productAddToCartForm += "<label for='option-upsell-product-template-" + y + "' class='ColorSwatch ColorSwatch--large' style='background-image: url(" + newSetColorSwarchImages1[y] + ")'><span class='u-visually-hidden'>" + newSetColorOptions1[y] + "</span></label>";
                            productAddToCartForm += "</li>";
                        }

                        productAddToCartForm += "</ul>";
                    } else {
                        productAddToCartForm += "<ul class='SizeSwatchList HorizontalList HorizontalList--spacingTight'>";

                        var sizeOptions = [];

                        for (var x = 0; x < variants.length; x++) {
                            sizeOptions.push(variants[x].options[1]);
                        }

                        var newSetSizeOptions = new Set(sizeOptions);
                        var newSetSizeOptions1 = [...newSetSizeOptions];

                        for (var y = 0; y < newSetSizeOptions1.length; y++) {
                            var checkedSizeValue = "";

                            if (selectedSizeValue == newSetSizeOptions1[y]) {
                                checkedSizeValue = "checked";
                            }

                            productAddToCartForm += "<li class='HorizontalList__Item' data-color='" + selectedColorValue + "'>";
                            productAddToCartForm += "<input type='radio' id='option-upsell-product-template-" + y + "-" + newSetSizeOptions1[y] + "' class='SizeSwatch__Radio' name='option-2' value='" + newSetSizeOptions1[y] + "' data-option-position='" + (j + 2) + "' " + checkedSizeValue + ">";
                            productAddToCartForm += "<label for='option-upsell-product-template-" + y + "-" + newSetSizeOptions1[y] + "' class='SizeSwatch'>" + newSetSizeOptions1[y] + "</label>";
                            productAddToCartForm += "</li>";
                        }

                        productAddToCartForm += "</ul>";
                    }
                }

                var variantAvailable = false;
                var addToCartBttonClass = "Button--secondary";
                var addToCartBttonAction = "disabled='disabled'";
                var addToCartBttonText = "Sold Out";

                for (var z = 0; z < variants.length; z++) {
                    if (variants[z].id == selectedVariantId) {
                        if(variants[z].available == true) {
                            variantAvailable = true
                        }
                    }
                }

                if (variantAvailable == true) {
                    addToCartBttonClass = "Button--primary";
                    addToCartBttonAction = "data-action='add-to-cart-upsell'";
                    addToCartBttonText = "Add To Cart";
                }

                productAddToCartForm += "<button class='ProductForm__AddToCart__Upsell Button " + addToCartBttonClass + " Button--full' " + addToCartBttonAction + "><span>" + addToCartBttonText + "</span></button>";
                productAddToCartForm += "</div>";
                productAddToCartForm += "</form>";

                $('.selected-upsell-product-wrapper .product-info-wrapper .productForm__Wrapper').html(productAddToCartForm);
                
                setTimeout(function() {
                    $('.QuickShopDrawer').addClass('active');
                    $('.QuickShopDrawer-overlay').removeClass('hidden');
                    $('body.template-product').addClass('scroll-lock');

                    $('.upsell-product-form input[type=radio][name=option-1]').change(function() {
                        var checkedColorValue = $(this).val();
                        var checkedSizeValue = "";
                        var variantAvailable = false;

                        if ($('.upsell-product-form input[type=radio][name=option-2]')) {
                            checkedSizeValue = $('.upsell-product-form input[type=radio][name=option-2]:checked').val();
                        }

                        for (var a = 0; a < variants.length; a++) {
                            if (variants[a].option1 == checkedColorValue && variants[a].option2 == checkedSizeValue) {
                                selectedVariantId = variants[a].id;

                                if (variants[a].available == true) {
                                    variantAvailable = true;
                                }
                            }
                        }

                        $('.upsell-product-form input[name=id]').val(selectedVariantId);
                        $('.upsell-product-form .ProductForm__Label__Color').text("Color: " + checkedColorValue);

                        if (variantAvailable == true) {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', false);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Add To Cart');
                        } else {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', true);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Sold Out');
                        }
                    });

                    $('.upsell-product-form input[type=radio][name=option-2]').change(function() {
                        var checkedSizeValue = $(this).val();
                        var checkedColorValue = $('.upsell-product-form input[type=radio][name=option-1]:checked').val();
                        var variantAvailable = false;

                        for (var a = 0; a < variants.length; a++) {
                            if (variants[a].option1 == checkedColorValue && variants[a].option2 == checkedSizeValue) {
                                selectedVariantId = variants[a].id;

                                if (variants[a].available == true) {
                                    variantAvailable = true;
                                }
                            }
                        }

                        $('.upsell-product-form input[name=id]').val(selectedVariantId);

                        if (variantAvailable == true) {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', false);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Add To Cart');
                        } else {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', true);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Sold Out');
                        }
                    });
                }, 100);
            });
        });

        /**
         * 2 column featured products
         */

        $('.two-column-featured-products-container .image-item-link__product-link').each(function(index) {
            $(this).on('click', function(e) {
                e.preventDefault();

                var productInfo = $.parseJSON($(this).next().text());

                var productImages = productInfo.product.images;
                var productTitle = productInfo.product.title;
                var productPrice = productInfo.product.price / 100;
                // var productDescription = productInfo.product.description;
                var productId = productInfo.product.id;
                var productOptions = productInfo.product.options;
                var selectedVariantId = productInfo.selected_variant_id;
                var variants = productInfo.product.variants;
                
                var productImageHTML = "";
                var productMetaInfoHTML = "";

                for(var i = 0; i < productImages.length; i++) {
                    productImageHTML += "<div class='product-image'><img class='Image--fadeIn Image--lazyLoaded' src='" + productImages[i] + "'></div>";
                }

                $('.product-image-wrapper').html(productImageHTML);

                productMetaInfoHTML += "<h1 class='ProductMeta__Title Heading u-h4'>" + productTitle + "</h1>";
                productMetaInfoHTML += "<div class='ProductMeta__PriceList Heading'><span class='ProductMeta__Price Price Text--subdued u-h4'>" + USDollar.format(productPrice) + "</span></div>";
                // productMetaInfoHTML += "<div class='ProductMeta__Description'>" + productDescription + "</div>";

                $('.selected-upsell-product-wrapper .ProductMeta').html(productMetaInfoHTML);

                var productAddToCartForm = "<form method='post' class='upsell-product-form' action='/cart/add' id='product_form_" + productId + "' accept-charset='UTF-8' enctype='multipart/form-data'>";
                productAddToCartForm += "<input type='hidden' name='product-id' value='" + productId + "'>";
                productAddToCartForm += "<input type='hidden' name='quantity' value='1'>";
                productAddToCartForm += "<input type='hidden' name='id' value='" + selectedVariantId + "'>";
                productAddToCartForm += "<div class='ProductForm__Variants'>";

                for (var j = 0; j < productOptions.length; j++) {
                    var optionName = productOptions[j];
                    var selectedColorValue = "";
                    var selectedSizeValue = "";
                    var colorOptionClass = "";
                    
                    for (var k = 0; k < variants.length; k++) {
                        if (selectedVariantId === variants[k].id) {
                            if (optionName == 'Color') {
                                selectedColorValue = variants[k].options[0];
                                colorOptionClass = "ProductForm__Label__Color";
                            } else {
                                selectedSizeValue = variants[k].options[1];
                            }
                        }
                    }

                    productAddToCartForm += "<span class='ProductForm__Label " + colorOptionClass + "'>" + optionName + ": " + selectedColorValue;
                    productAddToCartForm += "</span>";

                    if (optionName == 'Color') {
                        productAddToCartForm += "<ul class='ColorSwatchList HorizontalList HorizontalList--spacingTight'>";

                        var colorOptions = [];
                        var colorSwatchImages = [];

                        for (var x = 0; x < variants.length; x++) {
                            colorOptions.push(variants[x].options[0]);
                            colorSwatchImages.push(variants[x].featured_image.src);
                        }
                        
                        var newSetColorOptions = new Set(colorOptions);
                        var newSetColorOptions1 = [...newSetColorOptions];

                        var newSetColorSwarchImages = new Set(colorSwatchImages);
                        var newSetColorSwarchImages1 = [...newSetColorSwarchImages];

                        for (var y = 0; y < newSetColorOptions1.length; y++) {
                            var checkedColorValue = "";

                            if (selectedColorValue == newSetColorOptions1[y]) {
                                checkedColorValue = "checked";
                            }

                            productAddToCartForm += "<li class='HorizontalList__Item'>";
                            productAddToCartForm += "<input type='radio' id='option-upsell-product-template-" + y + "' class='ColorSwatch__Radio' name='option-1' value='" + newSetColorOptions1[y] + "' data-option-position='" + (j + 1) + "' " + checkedColorValue + ">";
                            productAddToCartForm += "<label for='option-upsell-product-template-" + y + "' class='ColorSwatch ColorSwatch--large' style='background-image: url(" + newSetColorSwarchImages1[y] + ")'><span class='u-visually-hidden'>" + newSetColorOptions1[y] + "</span></label>";
                            productAddToCartForm += "</li>";
                        }

                        productAddToCartForm += "</ul>";
                    } else {
                        productAddToCartForm += "<ul class='SizeSwatchList HorizontalList HorizontalList--spacingTight'>";

                        var sizeOptions = [];

                        for (var x = 0; x < variants.length; x++) {
                            sizeOptions.push(variants[x].options[1]);
                        }

                        var newSetSizeOptions = new Set(sizeOptions);
                        var newSetSizeOptions1 = [...newSetSizeOptions];

                        for (var y = 0; y < newSetSizeOptions1.length; y++) {
                            var checkedSizeValue = "";

                            if (selectedSizeValue == newSetSizeOptions1[y]) {
                                checkedSizeValue = "checked";
                            }

                            productAddToCartForm += "<li class='HorizontalList__Item' data-color='" + selectedColorValue + "'>";
                            productAddToCartForm += "<input type='radio' id='option-upsell-product-template-" + y + "-" + newSetSizeOptions1[y] + "' class='SizeSwatch__Radio' name='option-2' value='" + newSetSizeOptions1[y] + "' data-option-position='" + (j + 2) + "' " + checkedSizeValue + ">";
                            productAddToCartForm += "<label for='option-upsell-product-template-" + y + "-" + newSetSizeOptions1[y] + "' class='SizeSwatch'>" + newSetSizeOptions1[y] + "</label>";
                            productAddToCartForm += "</li>";
                        }

                        productAddToCartForm += "</ul>";
                    }
                }

                var variantAvailable = false;
                var addToCartBttonClass = "Button--secondary";
                var addToCartBttonAction = "disabled='disabled'";
                var addToCartBttonText = "Sold Out";

                for (var z = 0; z < variants.length; z++) {
                    if (variants[z].id == selectedVariantId) {
                        if(variants[z].available == true) {
                            variantAvailable = true
                        }
                    }
                }

                if (variantAvailable == true) {
                    addToCartBttonClass = "Button--primary";
                    addToCartBttonAction = "data-action='add-to-cart-upsell'";
                    addToCartBttonText = "Add To Cart";
                }

                productAddToCartForm += "<button class='ProductForm__QuickShop ProductForm__AddToCart__Upsell Button " + addToCartBttonClass + " Button--full' " + addToCartBttonAction + "><span>" + addToCartBttonText + "</span></button>";
                productAddToCartForm += "</div>";
                productAddToCartForm += "</form>";

                $('.selected-upsell-product-wrapper .product-info-wrapper .productForm__Wrapper').html(productAddToCartForm);
                
                setTimeout(function() {
                    $('.QuickShopDrawer').addClass('active');
                    $('.QuickShopDrawer-overlay').removeClass('hidden');
                    $('body.template-product').addClass('scroll-lock');

                    $('.upsell-product-form input[type=radio][name=option-1]').change(function() {
                        var checkedColorValue = $(this).val();
                        var checkedSizeValue = "";
                        var variantAvailable = false;

                        if ($('.upsell-product-form input[type=radio][name=option-2]')) {
                            checkedSizeValue = $('.upsell-product-form input[type=radio][name=option-2]:checked').val();
                        }

                        for (var a = 0; a < variants.length; a++) {
                            if (variants[a].option1 == checkedColorValue && variants[a].option2 == checkedSizeValue) {
                                selectedVariantId = variants[a].id;

                                if (variants[a].available == true) {
                                    variantAvailable = true;
                                }
                            }
                        }

                        $('.upsell-product-form input[name=id]').val(selectedVariantId);
                        $('.upsell-product-form .ProductForm__Label__Color').text("Color: " + checkedColorValue);

                        if (variantAvailable == true) {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', false);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Add To Cart');
                        } else {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', true);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Sold Out');
                        }
                    });

                    $('.upsell-product-form input[type=radio][name=option-2]').change(function() {
                        var checkedSizeValue = $(this).val();
                        var checkedColorValue = $('.upsell-product-form input[type=radio][name=option-1]:checked').val();
                        var variantAvailable = false;

                        for (var a = 0; a < variants.length; a++) {
                            if (variants[a].option1 == checkedColorValue && variants[a].option2 == checkedSizeValue) {
                                selectedVariantId = variants[a].id;

                                if (variants[a].available == true) {
                                    variantAvailable = true;
                                }
                            }
                        }

                        $('.upsell-product-form input[name=id]').val(selectedVariantId);

                        if (variantAvailable == true) {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', false);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Add To Cart');
                        } else {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', true);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Sold Out');
                        }
                    });

                    $('.ProductForm__QuickShop').on('click', function(e) {
                        e.preventDefault();

                        $(this).prop('disabled', true);
                        document.dispatchEvent(new CustomEvent('theme:loading:start'));

                        var form = $('.upsell-product-form');

                        var selectedVariantId = form.find('[name="id"]').val();
    
                        let formData = {
                            'items': [{
                                'id': selectedVariantId,
                                'quantity': 1
                             }]
                        };
                        
                        fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: {
                            'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formData)
                        })
                        .then(response => {
                            document.dispatchEvent(new CustomEvent('theme:loading:end'));
                            if (response['ok'] == true) {
                                $(this).prop('disabled', false);

                                document.dispatchEvent(new CustomEvent('product:added', {
                                    bubbles: true,
                                    detail: {
                                      variant: selectedVariantId,
                                      quantity: 1
                                    }
                                }));
                            }
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                    });
                }, 100);
            });
        });

        /**
         * Landscape featured products
         */
        $('.landscape-featured-products-container .image-item-link').each(function(index) {
            $(this).on('click', function(e) {
                e.preventDefault();
                
                var productInfo = $.parseJSON($(this).find('.image-item').next().text());

                var productImages = productInfo.product.images;
                var productTitle = productInfo.product.title;
                var productPrice = productInfo.product.price / 100;
                // var productDescription = productInfo.product.description;
                var productId = productInfo.product.id;
                var productOptions = productInfo.product.options;
                var selectedVariantId = productInfo.selected_variant_id;
                var variants = productInfo.product.variants;
                
                var productImageHTML = "";
                var productMetaInfoHTML = "";

                for(var i = 0; i < productImages.length; i++) {
                    productImageHTML += "<div class='product-image'><img class='Image--fadeIn Image--lazyLoaded' src='" + productImages[i] + "'></div>";
                }

                $('.product-image-wrapper').html(productImageHTML);

                productMetaInfoHTML += "<h1 class='ProductMeta__Title Heading u-h4'>" + productTitle + "</h1>";
                productMetaInfoHTML += "<div class='ProductMeta__PriceList Heading'><span class='ProductMeta__Price Price Text--subdued u-h4'>" + USDollar.format(productPrice) + "</span></div>";
                // productMetaInfoHTML += "<div class='ProductMeta__Description'>" + productDescription + "</div>";

                $('.selected-upsell-product-wrapper .product-info-wrapper .ProductMeta').html(productMetaInfoHTML);

                var productAddToCartForm = "<form method='post' class='upsell-product-form' action='/cart/add' id='product_form_" + productId + "' accept-charset='UTF-8' enctype='multipart/form-data'>";
                productAddToCartForm += "<input type='hidden' name='product-id' value='" + productId + "'>";
                productAddToCartForm += "<input type='hidden' name='quantity' value='1'>";
                productAddToCartForm += "<input type='hidden' name='id' value='" + selectedVariantId + "'>";
                productAddToCartForm += "<div class='ProductForm__Variants'>";

                for (var j = 0; j < productOptions.length; j++) {
                    var optionName = productOptions[j];
                    var selectedColorValue = "";
                    var selectedSizeValue = "";
                    var colorOptionClass = "";
                    
                    for (var k = 0; k < variants.length; k++) {
                        if (selectedVariantId === variants[k].id) {
                            if (optionName == 'Color') {
                                selectedColorValue = variants[k].options[0];
                                colorOptionClass = "ProductForm__Label__Color";
                            } else {
                                selectedSizeValue = variants[k].options[1];
                            }
                        }
                    }

                    productAddToCartForm += "<span class='ProductForm__Label " + colorOptionClass + "'>" + optionName + ": " + selectedColorValue;
                    productAddToCartForm += "</span>";

                    if (optionName == 'Color') {
                        productAddToCartForm += "<ul class='ColorSwatchList HorizontalList HorizontalList--spacingTight'>";

                        var colorOptions = [];
                        var colorSwatchImages = [];

                        for (var x = 0; x < variants.length; x++) {
                            colorOptions.push(variants[x].options[0]);
                            colorSwatchImages.push(variants[x].featured_image.src);
                        }
                        
                        var newSetColorOptions = new Set(colorOptions);
                        var newSetColorOptions1 = [...newSetColorOptions];

                        var newSetColorSwarchImages = new Set(colorSwatchImages);
                        var newSetColorSwarchImages1 = [...newSetColorSwarchImages];

                        for (var y = 0; y < newSetColorOptions1.length; y++) {
                            var checkedColorValue = "";

                            if (selectedColorValue == newSetColorOptions1[y]) {
                                checkedColorValue = "checked";
                            }

                            productAddToCartForm += "<li class='HorizontalList__Item'>";
                            productAddToCartForm += "<input type='radio' id='option-upsell-product-template-" + y + "' class='ColorSwatch__Radio' name='option-1' value='" + newSetColorOptions1[y] + "' data-option-position='" + (j + 1) + "' " + checkedColorValue + ">";
                            productAddToCartForm += "<label for='option-upsell-product-template-" + y + "' class='ColorSwatch ColorSwatch--large' style='background-image: url(" + newSetColorSwarchImages1[y] + ")'><span class='u-visually-hidden'>" + newSetColorOptions1[y] + "</span></label>";
                            productAddToCartForm += "</li>";
                        }

                        productAddToCartForm += "</ul>";
                    } else {
                        productAddToCartForm += "<ul class='SizeSwatchList HorizontalList HorizontalList--spacingTight'>";

                        var sizeOptions = [];

                        for (var x = 0; x < variants.length; x++) {
                            sizeOptions.push(variants[x].options[1]);
                        }

                        var newSetSizeOptions = new Set(sizeOptions);
                        var newSetSizeOptions1 = [...newSetSizeOptions];

                        for (var y = 0; y < newSetSizeOptions1.length; y++) {
                            var checkedSizeValue = "";

                            if (selectedSizeValue == newSetSizeOptions1[y]) {
                                checkedSizeValue = "checked";
                            }

                            productAddToCartForm += "<li class='HorizontalList__Item' data-color='" + selectedColorValue + "'>";
                            productAddToCartForm += "<input type='radio' id='option-upsell-product-template-" + y + "-" + newSetSizeOptions1[y] + "' class='SizeSwatch__Radio' name='option-2' value='" + newSetSizeOptions1[y] + "' data-option-position='" + (j + 2) + "' " + checkedSizeValue + ">";
                            productAddToCartForm += "<label for='option-upsell-product-template-" + y + "-" + newSetSizeOptions1[y] + "' class='SizeSwatch'>" + newSetSizeOptions1[y] + "</label>";
                            productAddToCartForm += "</li>";
                        }

                        productAddToCartForm += "</ul>";
                    }
                }

                var variantAvailable = false;
                var addToCartBttonClass = "Button--secondary";
                var addToCartBttonAction = "disabled='disabled'";
                var addToCartBttonText = "Sold Out";

                for (var z = 0; z < variants.length; z++) {
                    if (variants[z].id == selectedVariantId) {
                        if(variants[z].available == true) {
                            variantAvailable = true
                        }
                    }
                }

                if (variantAvailable == true) {
                    addToCartBttonClass = "Button--primary";
                    addToCartBttonAction = "data-action='add-to-cart-upsell'";
                    addToCartBttonText = "Add To Cart";
                }

                productAddToCartForm += "<button class='ProductForm__QuickShop ProductForm__AddToCart__Upsell Button " + addToCartBttonClass + " Button--full' " + addToCartBttonAction + "><span>" + addToCartBttonText + "</span></button>";
                productAddToCartForm += "</div>";
                productAddToCartForm += "</form>";

                $('.selected-upsell-product-wrapper .product-info-wrapper .productForm__Wrapper').html(productAddToCartForm);
                
                setTimeout(function() {
                    $('.QuickShopDrawer').addClass('active');
                    $('.QuickShopDrawer-overlay').removeClass('hidden');
                    $('body.template-product').addClass('scroll-lock');

                    $('.upsell-product-form input[type=radio][name=option-1]').change(function() {
                        var checkedColorValue = $(this).val();
                        var checkedSizeValue = "";
                        var variantAvailable = false;

                        if ($('.upsell-product-form input[type=radio][name=option-2]')) {
                            checkedSizeValue = $('.upsell-product-form input[type=radio][name=option-2]:checked').val();
                        }

                        for (var a = 0; a < variants.length; a++) {
                            if (variants[a].option1 == checkedColorValue && variants[a].option2 == checkedSizeValue) {
                                selectedVariantId = variants[a].id;

                                if (variants[a].available == true) {
                                    variantAvailable = true;
                                }
                            }
                        }

                        $('.upsell-product-form input[name=id]').val(selectedVariantId);
                        $('.upsell-product-form .ProductForm__Label__Color').text("Color: " + checkedColorValue);

                        if (variantAvailable == true) {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', false);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Add To Cart');
                        } else {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', true);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Sold Out');
                        }
                    });

                    $('.upsell-product-form input[type=radio][name=option-2]').change(function() {
                        var checkedSizeValue = $(this).val();
                        var checkedColorValue = $('.upsell-product-form input[type=radio][name=option-1]:checked').val();
                        var variantAvailable = false;

                        for (var a = 0; a < variants.length; a++) {
                            if (variants[a].option1 == checkedColorValue && variants[a].option2 == checkedSizeValue) {
                                selectedVariantId = variants[a].id;

                                if (variants[a].available == true) {
                                    variantAvailable = true;
                                }
                            }
                        }

                        $('.upsell-product-form input[name=id]').val(selectedVariantId);

                        if (variantAvailable == true) {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', false);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Add To Cart');
                        } else {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', true);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Sold Out');
                        }
                    });

                    $('.ProductForm__QuickShop').on('click', function(e) {
                        e.preventDefault();

                        $(this).prop('disabled', true);
                        document.dispatchEvent(new CustomEvent('theme:loading:start'));

                        var form = $('.upsell-product-form');

                        var selectedVariantId = form.find('[name="id"]').val();
    
                        let formData = {
                            'items': [{
                                'id': selectedVariantId,
                                'quantity': 1
                             }]
                        };
                        
                        fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: {
                            'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formData)
                        })
                        .then(response => {
                            document.dispatchEvent(new CustomEvent('theme:loading:end'));
                            if (response['ok'] == true) {
                                $(this).prop('disabled', false);

                                document.dispatchEvent(new CustomEvent('product:added', {
                                    bubbles: true,
                                    detail: {
                                      variant: selectedVariantId,
                                      quantity: 1
                                    }
                                }));
                            }
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                    });
                }, 100);
            });
        });

        $('.QuickShopDrawer .close-button').on('click', function() {
            $('.QuickShopDrawer').removeClass('active');
            $('.QuickShopDrawer-overlay').addClass('hidden');
            $('body.template-product').removeClass('scroll-lock');
        });
    })



    /**
     * Ajax Contact form
     */

    function CopyToClipboard(id)
    {
        var r = document.createRange();
        r.selectNode(document.getElementById(id));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(r);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        document.querySelector('.copied-message').style.display = "block";
        setTimeout(function(){
            document.querySelector('.copied-message').style.display = "none";
        }, 3000)
    }

    if(document.querySelector('.Alert--success .copy-icon')) {
        document.querySelector('.Alert--success .copy-icon').addEventListener('click', function () {
            CopyToClipboard('copy_clip');
        });
    }

    function formToJSON(elements) {
        return [].reduce.call(elements, function (data, element) {
            data[element.name] = element.value;
            return data;
        }, {});
    }
    
    // Get Shopify Friendly URL String
    function getUrlString(data) {
        var urlParameters = Object.entries(data).map(function (e) {
            return e.join('=');
        }).join('&');
    
        return urlParameters;
    }
    
    function ajaxFormInit(form) {
        var form_type = form.querySelector("[name=form_type]").value,
            inputs = form.querySelectorAll("[name]"),
            alert = form.querySelector('[data-alert="status"]'),
            alert_msgs = form.querySelector('.Form__Alert');
    
        form.addEventListener('submit', function(e){
            e.preventDefault();
    
            var action = form.getAttribute("action");
    
            fetch(action, {
                method: 'POST',
                body: getUrlString(formToJSON(inputs)),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'Accept': 'text/html, */*; q=0.01',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(function(response) {
                console.log(response);
                console.log(response.status);
    
                if (alert) {
                    console.log("alert: " + alert);
                    alert.className = "Alert Alert-success";
                    // alert.innerHTML = alert_msg.success;
                }
                
                form.querySelector('input').style.display = "none";
                form.querySelector('input[type=email]').style.display = "none";
                form.querySelector('.select-people-items').style.display = "none";
                form.querySelector('.Form__Submit').style.display = "none";
                document.querySelector('.popup-image').style.display = "none";
                document.querySelector('.NewsletterPopup__Content').style.display = "none";
                
                alert_msgs.style.display = "block";

            }).catch(function(err) {
                console.error(err);
    
                if (alert) {
                    alert.className = "alert alert-error";
                    alert.innerHTML = alert_msg.error;
                }
            });
        });
    }
    
    // Init Shopify Forms
    document.querySelectorAll("[name=form_type]").forEach(function(el) {
        ajaxFormInit(el.closest("form"));
    });
})(jQuery);

/* =============================================================
   WILLBO MEGA MENU — v6
   Fix: remove legacy WillboMenuOverlay from DOM (it was
   intercepting mouseover events and triggering closeAll).
   Fix: don't scheduleClose when just moving within the header.
   ============================================================= */
(function () {
  'use strict';

  var closeTimer = null;

  // Remove any lingering overlay divs from old JS versions
  function removeOldOverlays() {
    document.querySelectorAll('.WillboMenuOverlay').forEach(function(el) {
      el.remove();
    });
  }

  // Get the direct-child MegaMenu of a nav li
  function getDirectMenu(li) {
    var children = li.children;
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (c.classList.contains('MegaMenu') || c.classList.contains('MegaMenu-1')) {
        return c;
      }
    }
    return null;
  }

  function openMenu(li) {
    cancelClose();
    // Close all others
    document.querySelectorAll('.Header__MainNav .HorizontalList__Item').forEach(function (other) {
      if (other !== li) {
        var m = getDirectMenu(other);
        if (m) m.setAttribute('aria-hidden', 'true');
      }
    });
    // Open this one
    var menu = getDirectMenu(li);
    if (menu) menu.setAttribute('aria-hidden', 'false');
  }

  function closeAll() {
    document.querySelectorAll('.Header__MainNav .HorizontalList__Item').forEach(function (li) {
      var m = getDirectMenu(li);
      if (m) m.setAttribute('aria-hidden', 'true');
    });
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeAll, 150);
  }

  function cancelClose() {
    clearTimeout(closeTimer);
  }

  function isTouch() {
    return window.matchMedia('(hover: none)').matches;
  }

  // --- mouseover: open menus ---
  document.addEventListener('mouseover', function (e) {
    if (isTouch()) return;

    // Ignore legacy overlay div if it somehow still exists
    if (e.target.classList && e.target.classList.contains('WillboMenuOverlay')) {
      return;
    }

    // Are we inside a nav item with a mega menu?
    var li = e.target.closest && e.target.closest('.Header__MainNav .HorizontalList__Item');
    if (li) {
      var menu = getDirectMenu(li);
      if (menu) {
        openMenu(li);
        return;
      }
      // Nav item without a menu — don't schedule close, just let it be
      return;
    }

    // Inside an open mega menu?
    var inMenu = e.target.closest && (
      e.target.closest('.Header__MainNav .MegaMenu') ||
      e.target.closest('.Header__MainNav .MegaMenu-1')
    );
    if (inMenu) {
      cancelClose();
      return;
    }

    // Inside header but not a nav item or menu — schedule close
    var inHeader = e.target.closest && e.target.closest('.Header');
    if (inHeader) {
      scheduleClose();
      return;
    }

    // Outside header entirely
    scheduleClose();
  });

  // --- mouseout: close when leaving header ---
  document.addEventListener('mouseout', function (e) {
    if (isTouch()) return;
    var to = e.relatedTarget;
    if (!to) { scheduleClose(); return; }
    // If going to something inside the header, don't close
    if (to.closest && to.closest('.Header')) return;
    scheduleClose();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.Header')) closeAll();
  });

  // Init: remove old overlays now and on any section reload
  removeOldOverlays();
  document.addEventListener('shopify:section:load', function () {
    removeOldOverlays();
  });

})();

/* ─── EXPERIENCE MENU SCROLL BAR ────────────────────────────── */
(function () {

  // Inject bar once into the wrap — called after DOM ready
  function ensureBar() {
    var wrap = document.querySelector('.WillboExpWrap');
    if (!wrap || wrap.querySelector('.WillboExpBar')) return;
    var bar = document.createElement('div');
    bar.className = 'WillboExpBar';
    bar.innerHTML = '<div class="WillboExpBarFill"></div>';
    wrap.appendChild(bar);
  }

  // Update bar width based on current scrollLeft
  function updateBar(scroller) {
    var barFill = document.querySelector('.WillboExpBarFill');
    if (!barFill) { ensureBar(); barFill = document.querySelector('.WillboExpBarFill'); }
    if (!barFill) return;
    var maxScroll = scroller.scrollWidth - scroller.clientWidth;
    if (maxScroll <= 0) return;
    var progress = Math.min(1, scroller.scrollLeft / maxScroll);
    barFill.style.width = (8 + progress * 92) + '%';
  }

  // Capture-phase scroll listener — scroll doesn't bubble so capture is required
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.id === 'willbo-exp-scroller') {
      updateBar(e.target);
    }
  }, true);

  // Inject bar as soon as DOM is ready — no resets, no scrollLeft manipulation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureBar);
  } else {
    ensureBar();
  }

})();

/* MOBILE STICKY TITLE BAR — handled purely via CSS position:fixed on .ProductMeta */

/* ─── WESTERN CONDITIONS: TAHOE STREAMFLOW SAFEGUARD ─────────── */
(function () {
  function shouldRun() {
    return window.location && window.location.pathname === '/pages/western-conditions';
  }

  function latestUsgsValue(data) {
    try {
      var series = data.value.timeSeries || [];
      for (var i = 0; i < series.length; i++) {
        var values = series[i].values && series[i].values[0] && series[i].values[0].value ? series[i].values[0].value : [];
        for (var j = values.length - 1; j >= 0; j--) {
          if (values[j].value !== undefined && values[j].value !== '') return values[j].value;
        }
      }
    } catch (e) {}
    return null;
  }

  function cfs(value) {
    var n = Number(value);
    return Number.isNaN(n) ? null : Math.round(n) + ' cfs';
  }

  function writeStreamflow(flow) {
    var root = document.querySelector('[data-western-conditions]');
    if (!root) return;

    var display = cfs(flow);
    if (!display) return;

    var field = root.querySelector('[data-field="mountains.streamflow"]') || root.querySelector('[data-field="mountains.lake"]');
    if (field) {
      var label = field.closest('div') ? field.closest('div').querySelector('dt') : null;
      if (label) label.textContent = 'Streamflow';
      field.setAttribute('data-field', 'mountains.streamflow');
      field.textContent = display;
    }

    var note = root.querySelector('[data-note="mountains"]');
    if (note && note.textContent) {
      if (note.textContent.indexOf('through the Truckee') > -1) {
        note.textContent = note.textContent.replace(/, [0-9,]+ cfs through the Truckee/g, ', ' + display + ' through the Truckee');
      } else {
        note.textContent = note.textContent.replace(/, and /, ', ' + display + ' through the Truckee, and ');
      }
    }
  }

  function fetchStreamflow(index) {
    var urls = [
      'https://waterservices.usgs.gov/nwis/iv/?format=json&sites=10337500&parameterCd=00060&period=P1D&siteStatus=all',
      'https://waterservices.usgs.gov/nwis/iv/?format=json&sites=10337500&parameterCd=00060&period=P7D&siteStatus=all'
    ];

    if (index >= urls.length) return;

    fetch(urls[index] + '&_willbo=' + Date.now())
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var flow = latestUsgsValue(data);
        if (flow === null) throw new Error('Truckee streamflow unavailable');
        writeStreamflow(flow);
      })
      .catch(function () {
        fetchStreamflow(index + 1);
      });
  }

  function run() {
    if (!shouldRun()) return;
    fetchStreamflow(0);
    setTimeout(function () { fetchStreamflow(1); }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
/* WILLBO: mobile SHOP menu SPORT fallback
   Keeps the drawer in sync with desktop SPORT without changing existing styling.
   If Liquid/navigation already renders SPORT, this does nothing. */
(function () {
  function ensureWillboMobileSportColumn() {
    var shopCols = document.querySelector('.WillboMobileNav__ShopCols');
    if (!shopCols || shopCols.querySelector('[data-col-id="sport"]')) return;

    var sportCol = document.createElement('div');
    sportCol.className = 'WillboMobileNav__ShopCol';
    sportCol.setAttribute('data-col-id', 'sport');
    sportCol.innerHTML = [
      '<button class="WillboMobileNav__ColTrigger" data-col-toggle="sport">',
        '<span class="WillboMobileNav__ColLabel">Sport</span>',
        '<svg class="WillboMobileNav__ColChevron" width="10" height="10" viewBox="0 0 10 10" fill="none"><polyline points="2,3 5,7 8,3" stroke="currentColor" stroke-width="1.2" fill="none" stroke-linecap="round" stroke-linejoin="round"></polyline></svg>',
      '</button>',
      '<div class="WillboMobileNav__ColChildren">',
        '<a href="/collections/sport" class="WillboMobileNav__ColChild">View All</a>',
        '<a href="/collections/sport-headwear" class="WillboMobileNav__ColChild">Headwear</a>',
        '<a href="/collections/sport-tees-polos" class="WillboMobileNav__ColChild">Tees &amp; Polos</a>',
        '<a href="/collections/sport-quarter-zips" class="WillboMobileNav__ColChild">Quarter Zips</a>',
        '<a href="/collections/sport-bottoms" class="WillboMobileNav__ColChild">Bottoms</a>',
      '</div>'
    ].join('');

    shopCols.appendChild(sportCol);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureWillboMobileSportColumn);
  } else {
    ensureWillboMobileSportColumn();
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-drawer-id="sidebar-menu"], .WillboMobileNav__Trigger')) {
      window.setTimeout(ensureWillboMobileSportColumn, 50);
    }
  });
})();
